import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import {
  Box,
  Center,
  Stack,
  Button,
  Title,
  Modal,
  Text,
  Group,
  Image,
  Paper,
  ScrollArea,
  Card,
} from '@mantine/core';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { showNotification } from '@mantine/notifications';
import { CircleX } from 'tabler-icons-react';
import _ from 'lodash';
import { sendRequest } from '../../services/services';
import AppContext from '../Context/index';
import AlertImg from '../../image/alert.svg';
import Plate from '../../image/plate.svg';
import clock from '../../image/clock.svg';
import arrowUp from '../../image/arrow-up.svg';
import arrowRight from '../../image/arrow-right.svg';

const TicketSummary = ({ passId, name, mobileNumber }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const appContextState = useContext(AppContext);
  const { appState } = appContextState;
  const [ticketData, setTicketData] = useState();

  const [errorPos, setErrorPos] = useState(false);

  const [formatttedGroupedVas, setFormatttedGroupedVas] = useState([]);

  const selectedVas = JSON.parse(localStorage.getItem('selectedVas'));

  /** Formatted and groued the vas */
  const setformattedVas = (vasOrders) => {
    setFormatttedGroupedVas(
      _.map(_.groupBy(vasOrders, 'vas_sub_types.id'), (d) => ({
        name: d[0].vas_types?.name,
        subtype: d[0].vas_sub_types?.name,
        count: _.sumBy(d, 'qty'),
        amount: d[0].amount,
        name_ar: d[0].vas_types?.name_ar,
        name_ar_subtype: d[0].vas_sub_types?.name_ar,
      })),
    );
  };

  useEffect(() => {
    sendRequest(`parking/reservations-by-pass-id/${passId}`, 'get').then((res) => {
      if (res?.code === 20) {
        setTicketData(res?.data || []);
        if (res?.data?.result?.vas_orders?.length) {
          setformattedVas(res?.data?.result?.vas_orders);
        }
      } else if (res?.code === 21) {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
          icon: <CircleX size={16} />,
        });
      }
    });
  }, [passId]);

  const now = dayjs();
  let date1;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    date1 = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (!ticketData?.result?.tickets?.entry_time) {
    date1 = dayjs(ticketData?.result?.start_time);
  } else {
    date1 = dayjs(ticketData?.result?.tickets?.entry_time);
  }
  let date2;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    date2 = dayjs(now);
  } else if (ticketData?.result?.tickets?.ticket_status_types?.id === 3) {
    date2 = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (ticketData?.result?.tickets?.ticket_status_types?.id === 2) {
    date2 = dayjs(now);
  } else if (!ticketData?.result?.exit_time) {
    date2 = dayjs(now);
  } else if (!ticketData?.result?.tickets?.exit_time) {
    date2 = dayjs(ticketData?.result?.end_time);
  } else {
    date2 = dayjs(ticketData?.result?.tickets?.exit_time);
  }

  const TotalSeconds = date2.diff(date1, 'minutes');
  const hours = Math.ceil(TotalSeconds / 60);
  let startDate;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    startDate = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (!ticketData?.result?.tickets?.entry_time) {
    startDate = dayjs(ticketData?.result?.start_time);
  } else {
    startDate = dayjs(ticketData?.result?.tickets?.entry_time);
  }

  startDate = startDate.format('DD-MM-YYYY HH:mm').slice(0, -5);
  let startTime;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    startTime = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (!ticketData?.result?.tickets?.entry_time) {
    startTime = dayjs(ticketData?.result?.start_time);
  } else {
    startTime = dayjs(ticketData?.result?.tickets?.entry_time);
  }

  startTime = startTime.format('DD-MM-YYYY HH:mm').slice(10);

  let endDate;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    endDate = dayjs(now);
  } else if (ticketData?.result?.tickets?.ticket_status_types?.id === 3) {
    endDate = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 ||
    !ticketData?.result?.exit_time
  ) {
    endDate = dayjs(now);
  } else {
    endDate = dayjs(ticketData?.result?.end_time);
  }

  endDate = endDate.format('DD-MM-YYYY HH:mm').slice(0, -5);

  let endTime;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    endTime = dayjs(now);
  } else if (ticketData?.result?.tickets?.ticket_status_types?.id === 3) {
    endTime = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (!ticketData?.result?.exit_time) {
    endTime = dayjs(now);
  } else {
    endTime = dayjs(ticketData?.result?.end_time);
  }

  endTime = endTime.format('DD-MM-YYYY HH:mm').slice(10);

  const detailsPage = () => {
    navigate({
      pathname: '/services',
      search: createSearchParams({
        numberplate: ticketData?.result?.vehicles?.number_plate,
        tax: ticketData?.result?.invoices?.tax,
        passId,
      }).toString(),
    });
  };

  // Function to split the data where qty > 1 for vas_type_id: 2
  const splitSelectedVas = (vasData) => {
    const result = [];
    if (selectedVas && Array.isArray(vasData)) {
      vasData.forEach((item) => {
        if (item.qty > 1 && item.vas_type_id === 2) {
          for (let i = 0; i < item.qty; i += 1) {
            result.push({
              ...item,
              qty: 1, // Set qty to 1 for each new split entry
            });
          }
        } else {
          result.push(item);
        }
      });
    }
    return result;
  };

  const modifiedSelectedVas = splitSelectedVas(selectedVas);

  const addOnService = () => {
    const body = {
      pass_id: passId,
      vas: modifiedSelectedVas,
      mobile:
        mobileNumber === ''
          ? ticketData?.result?.guest_users?.mobile || ticketData?.result?.customers?.mobile
          : mobileNumber,
      first_name:
        name === ''
          ? ticketData?.result?.guest_users?.first_name || ticketData?.result?.customers?.full_name
          : name,
    };
    if (selectedVas) {
      sendRequest(`/parking/add-on-services`, 'patch', body)
        .then(({ code, msg }) => {
          if (code === 20) {
            sendRequest(`parking/reservations-by-pass-id/${passId}`, 'get').then((res) => {
              setTicketData(res?.data || []);
              if (res?.data?.result?.vas_orders?.length) {
                setformattedVas(res?.data?.result?.vas_orders);
              }
            });

            localStorage.removeItem('selectedVas');

            showNotification({
              title: <Text weight={500}>{msg}</Text>,
              icon: <CircleX size={16} />,
            });
          } else if (code === 40) {
            showNotification({
              title: <Text weight={500}>{msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        });
    }
  };

  const removeOnService = () => {
    localStorage.removeItem('selectedVas');
    window.location.reload();
  };

  const numberPlate = ticketData?.result?.tickets?.number_plate;
  const numericRegex = /\d+/g;
  const characterRegex = /[A-Za-z]+/g;

  const numberPlateNumericParts = numberPlate && numberPlate.match(numericRegex);
  const numberPlateCharacterParts = numberPlate && numberPlate.match(characterRegex);

  const testPayment = () => {
    navigate({
      pathname: '/pospayment',
      search: createSearchParams({
        passId,
      }).toString(),
    });
  };

  const invoicePage = () => {
    navigate({
      pathname: '/invoice',
      search: createSearchParams({
        passId,
        invoiceDataId: ticketData?.result?.invoices?.id,
      }).toString(),
    });
  };

  return (
    <Box
      className="no-printme"
      style={{
        height: 'fit-content',
        marginBottom: '24px',
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        justifyContent: 'space-between',
      }}
    >
      <Stack>
        <Title style={{ color: '#2C5864', margin: '1% 0' }} order={3}>
          {t('ticket.details')} #{ticketData?.result?.pass_id}
        </Title>
      </Stack>
      <Paper shadow="sm" p="lg" radius="lg" style={{ flex: '1' }}>
        <Group style={{ width: '100%', height: '100%' }} grow>
          <Stack justify="space-between" style={{ width: '100%', height: '100%' }}>
            <Stack px="md">
              <Group position="apart" grow>
                <Title order={4}>{t('ticket.description.text')}</Title>
                <Title order={4} style={{ textAlign: 'end' }}>
                  {t('ticket.amount.text')}
                </Title>
              </Group>
              <ScrollArea style={{ height: 'calc(100vh - 426px)' }}>
                {ticketData?.result?.reservation_types !== null ? (
                  <Group position="apart" grow style={{ marginBottom: 0.5, marginTop: 0.5 }}>
                    <Text weight={500} color="#817E7E">
                      {hours} {t('ticket.hours.parking.text')}
                    </Text>

                    <Text weight={500} color="#817E7E" style={{ textAlign: 'end' }}>
                      {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                        ? 0
                        : (Number(ticketData?.result?.amount) * hours).toFixed(2)}{' '}
                      {t('ticket.amount.sar.text')}
                    </Text>
                  </Group>
                ) : null}

                <Group position="apart" style={{ marginBottom: 0.5, marginTop: 0.5 }}>
                  <Text weight={500} color="#817E7E">
                    {appState?.language === 'en' ? (
                      <Text
                        weight={500}
                        color="#817E7E"
                        style={{ width: '210px', marginTop: '6px' }}
                      >
                        {formatttedGroupedVas.map((vas) => (
                          <div>
                            {vas.name} ({vas.subtype}) x {vas.count}
                          </div>
                        ))}
                      </Text>
                    ) : (
                      <>
                        {formatttedGroupedVas.map((vas) => (
                          <div>
                            {appState?.language === 'en' ? vas.name : vas.name_ar} (
                            {appState?.language === 'en' ? vas.subtype : vas.name_ar_subtype}) x{' '}
                            {vas.count}
                          </div>
                        ))}
                      </>
                    )}

                    {}
                  </Text>

                  <Text weight={500} color="#817E7E" style={{ textAlign: 'end' }}>
                    {formatttedGroupedVas.map((vas) => (
                      <div>
                        {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                          ? 0
                          : Number(vas.amount * vas.count).toFixed(2)}{' '}
                        {t('ticket.amount.sar.text')}
                      </div>
                    ))}
                  </Text>
                </Group>

                {ticketData?.result?.enforcements.map((em) => (
                  <Group position="apart" style={{ marginBottom: 0.5, marginTop: 0.5 }}>
                    <Text size="sm" weight={500} color="#817E7E">
                      {em?.name}
                    </Text>
                    <Text size="sm" weight={500} color="#817E7E">
                      {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                        ? 0
                        : Number(em?.amount).toFixed(2)}{' '}
                      {t('ticket.amount.sar.text')}
                    </Text>
                  </Group>
                ))}
              </ScrollArea>
            </Stack>
            <Card
              shadow="none"
              radius="md"
              p="md"
              style={{ width: '100%', backgroundColor: '#F6F6F6' }}
            >
              <Group position="apart" grow>
                <Text size="sm" style={{ lineHeight: 1.5 }}>
                  {t('ticket.tax.text')}(15%)
                </Text>
                <Text size="sm" style={{ lineHeight: 1.5, textAlign: 'end' }}>
                  {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                    ? 0
                    : ticketData?.result?.invoices?.tax.toFixed(2)}{' '}
                  {t('ticket.amount.sar')}
                </Text>
              </Group>

              <Group position="apart" grow>
                <Title order={4}>{t('ticket.amount.total.text')}</Title>
                <Title order={4} style={{ textAlign: 'end' }}>
                  {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                    ? 0
                    : ticketData?.result?.invoices?.payable_amount.toFixed(2)}{' '}
                  {t('ticket.amount.sar')}
                </Title>
              </Group>
              {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
                <Button
                  variant="filled"
                  color="teal"
                  radius="lg"
                  fullWidth
                  size="xl"
                  onClick={invoicePage}
                  disabled={selectedVas}
                  style={{ marginTop: '14px', backgroundColor: '#50A847' }}
                >
                  <Title order={3}>{t('invoice.for.ticket')}</Title>
                </Button>
              ) : (
                <Button
                  variant="filled"
                  color="teal"
                  radius="lg"
                  fullWidth
                  size="xl"
                  onClick={testPayment}
                  disabled={selectedVas}
                  style={{ marginTop: '14px', backgroundColor: '#50A847' }}
                >
                  <Title order={3}>{t('ticket.amount.pay.button.text')}</Title>
                </Button>
              )}
            </Card>
          </Stack>

          <Stack justify="space-between" style={{ width: '100%', height: '100%' }}>
            <div>
              <div className="container">
                <Image src={Plate} width={120} style={{ marginBottom: '8px' }} />

                <Text size="lg" className="top-left">
                  {numberPlateCharacterParts}
                </Text>
                <Text size="lg" className="top-right">
                  {numberPlateNumericParts}
                </Text>
              </div>
              <Card
                shadow="none"
                radius="md"
                p="xs"
                style={{ width: '100%', marginTop: '3px', backgroundColor: '#F6F6F6' }}
              >
                <Group position="apart" grow>
                  <Group>
                    <Image src={arrowRight} width={40} />
                    <Text size="lg" style={{ lineHeight: 1.5 }}>
                      {t('ticket.entry.text')}
                    </Text>
                  </Group>
                  <Text size="md" style={{ lineHeight: 1.5, textAlign: 'end' }}>
                    {startDate} <br />
                    {startTime}
                  </Text>
                </Group>
              </Card>
              <Card
                shadow="none"
                radius="md"
                p="xs"
                style={{ width: '100%', marginTop: '3px', backgroundColor: '#F6F6F6' }}
              >
                <Group position="apart" grow>
                  <Group>
                    <Image src={arrowUp} width={40} />
                    <Text size="lg" style={{ lineHeight: 1.5 }}>
                      {t('ticket.exit.text')}
                    </Text>
                  </Group>
                  <Text size="md" style={{ lineHeight: 1.5, textAlign: 'end' }}>
                    {endDate} <br />
                    {endTime}
                  </Text>
                </Group>
              </Card>
              {ticketData?.result?.reservation_types !== null ? (
                <Card
                  shadow="none"
                  radius="md"
                  p="md"
                  style={{ width: '100%', marginTop: '3px', backgroundColor: '#F6F6F6' }}
                >
                  <Group position="apart" grow>
                    <Group>
                      <Image src={clock} width={32} />
                      <Text size="lg" style={{ lineHeight: 1.5 }}>
                        {t('ticket.duration.text')}
                      </Text>
                    </Group>
                    <Text size="md" style={{ lineHeight: 1.5, textAlign: 'end' }}>
                      {hours} {t('ticket.hours.text')}
                    </Text>
                  </Group>
                </Card>
              ) : null}
            </div>

            {selectedVas ? (
              <Group position="apart">
                <Button
                  variant="filled"
                  color="teal"
                  radius="lg"
                  fullWidth
                  size="xl"
                  onClick={addOnService}
                  style={{ marginTop: '14px', backgroundColor: '#50A847', width: '48%' }}
                >
                  <Title order={3}>{t('confirm.button.text')}</Title>
                </Button>
                <Button
                  variant="filled"
                  color="teal"
                  radius="lg"
                  fullWidth
                  size="xl"
                  onClick={removeOnService}
                  style={{ marginTop: '14px', backgroundColor: '#50A847', width: '48%' }}
                >
                  <Title order={3}>{t('payment.cancel')}</Title>
                </Button>
              </Group>
            ) : null}
            <Button
              variant="filled"
              onClick={detailsPage}
              color="teal"
              radius="lg"
              fullWidth
              size="xl"
              style={{ marginTop: '14px', backgroundColor: '#2C5864', height: '72px' }}
              disabled={ticketData?.result?.invoices?.invoice_status?.name === 'paid'}
            >
              <Title order={3}>{t('ticket.amount.other.service.button.text')}</Title>
            </Button>
          </Stack>
        </Group>
      </Paper>

      <Modal opened={errorPos} onClose={() => setErrorPos(false)} centered size="50%">
        <Center>
          <Image src={AlertImg} width={100} />;
        </Center>
        <Center py="xl">
          <Title order={1}>Error with Connection</Title>
        </Center>
      </Modal>
    </Box>
  );
};
export default TicketSummary;
